var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerforceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66 60",
    style: {
      padding: ".5rem"
    },
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 300,
    height: 300,
    fontFamily: "Roboto",
    fontSize: "14px",
    textAnchor: "middle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.977 20.74c.425-1.12.935-2.208 1.527-3.25l-1.898-1.724c7.397-8.86 17.042-11.523 25.574-9.973 1.78.24 3.528.672 5.215 1.287 12.22 4.54 18.405 18.013 13.813 30.093-.458 1.2-1.026 2.357-1.637 3.426.676.6 2.16 1.68 2.073 1.768-8.205 9.7-19.137 11.958-28.236 9.252-.873-.218-1.746-.48-2.62-.786C11.6 46.292 5.394 32.83 9.977 20.74zM51.655.01l-4.32 4.08c-1.44-.807-3-1.55-4.604-2.138-13.88-5.16-28.5.677-36.55 11.522C1.968 19.692-.52 27.352.092 35.23c0 0 .022 14.816 13.704 23.545l3.47-4.757a32.75 32.75 0 0 0 4.844 2.29c15.7 5.827 33.123-1.615 38.82-16.615 0 0 4.168-9.143 2.793-19.137 0 0-1.07-13.485-12.067-20.555z",
    stroke: "none",
    fill: "#404040",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerforceIcon);
export default __webpack_public_path__ + "static/media/perforce-icon.fce46d1d2ec1c7ec9e64d78493d05b90.svg";
export { ForwardRef as ReactComponent };